import { useIntl } from '@/intl'
import { Banner } from '@sunwebgroup/ui-components/uds'

import { styled } from 'styled-components'

const BannerWrapper = styled.div`
  width: 100%;
`

function ParticipantsBanner({
  link,
  text,
}: {
  link?: {
    href: string
    text: string
  }
  text: string
}) {
  if (link) {
    return (
      <BannerWrapper>
        <a href={link.href}>
          <Banner color="secondary" text={text} size="S" supportingText={link.text} />
        </a>
      </BannerWrapper>
    )
  }

  return (
    <BannerWrapper>
      <Banner color="secondary" text={text} size="S" />
    </BannerWrapper>
  )
}

export function GroupLink() {
  const intl = useIntl()
  return (
    <ParticipantsBanner
      link={{
        href: '/vakantie/groepsreizen',
        text: intl.formatMessage({ id: 'quicksearch_filter_participants_group_travel_link_text' }),
      }}
      text={intl.formatMessage({ id: 'quicksearch_filter_participants_group_travel_description' }, { groupSize: 20 })}
    />
  )
}

export function ChildInfo() {
  const intl = useIntl()
  return <ParticipantsBanner text={intl.formatMessage({ id: 'quicksearch_filter_participants_description' })} />
}

export function ChildWithoutAdultRoomInfo() {
  const intl = useIntl()
  return (
    <ParticipantsBanner
      text={intl.formatMessage({ id: 'quicksearch_filter_participants_room_no_adults_description' })}
    />
  )
}
